import { Injectable } from '@angular/core';
import { affordabilityMatched } from '@clubhub/ignite/constants/ignite';
import { AnyAffordabilityRequest, ISortOption } from '@shared/models';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class AffordabilityService {
  public loading$ = new BehaviorSubject(false);
  public affordabilityPollStop$ = new Subject<void>();
  public affordabilityModelRequest: AnyAffordabilityRequest | null = null;
  public lastSavedAffordabilitySearchId: string | null = null;
  public affordabilityLoading$ = new BehaviorSubject(false);
  public affordabilityMatched: ISortOption[] = affordabilityMatched;

  public get loading() {
    return this.loading$.value;
  }

  public set loading(value: boolean) {
    this.loading$.next(value);
  }
}
